/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateThreadRequest
 */
export interface UpdateThreadRequest {
    /**
     * Must not be greater than 255 characters.
     * @type {string}
     * @memberof UpdateThreadRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateThreadRequest
     */
    body?: string;
}

/**
 * Check if a given object implements the UpdateThreadRequest interface.
 */
export function instanceOfUpdateThreadRequest(value: object): value is UpdateThreadRequest {
    return true;
}

export function UpdateThreadRequestFromJSON(json: any): UpdateThreadRequest {
    return UpdateThreadRequestFromJSONTyped(json, false);
}

export function UpdateThreadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateThreadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'body': json['body'] == null ? undefined : json['body'],
    };
}

export function UpdateThreadRequestToJSON(json: any): UpdateThreadRequest {
    return UpdateThreadRequestToJSONTyped(json, false);
}

export function UpdateThreadRequestToJSONTyped(value?: UpdateThreadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'body': value['body'],
    };
}

